module.exports = __webpack_public_path__ + "img/T71.2ffb579e.jpg";